<!--
 * @Description: 侧边栏
 * @Author: your name
 * @Date: 2019-05-24 10:23:44
 * @LastEditTime: 2019-05-27 12:59:32
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="slide-bar-wrapper">
    <div id="slide-bar-logo__dom" class="slide-bar-logo" />
    <div class="slide-bar-link-list">
      <el-menu class="el-menu-vertical-demo"
        :collapse="isCollapse">
        <template v-for="(item, idx) in menuList">
          <el-menu-item
            :key='idx' v-bind:index="'' + idx"
            @click="clickMunu(item.path)">
            <i :class='item.details.icon'></i>
            <span class="munu-font" >{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { getAllMenuList } from '../../libs/utils/getMenuList'

export default {
  name: 'slideBar',
  data() {
    return {
      isCollapse: false,
      menuList: []
    }
  },
  methods: {
    clickMunu(path) {
      this.$router.push(`/index/${path}`)
    },
    getMenuList() {
      getAllMenuList().then(res => {
        this.menuList = res
      })
    }
  },
  created() {
    this.getMenuList() // 获取权限
  },
  mounted() {
    this.$bus.$off('sliderBarSwitch')
    this.$bus.$on('sliderBarSwitch', () => {
      this.isCollapse = !this.isCollapse
      const logoEl = document.querySelector('#slide-bar-logo__dom')
      logoEl.classList.toggle('slide-bar-logo__close')
    })
  }
}
</script>

<style lang="scss" scoped>
.slide-bar-wrapper {
  background-color: #5081A1;
  & > .slide-bar-logo {
    width: 190px;
    height: 166px;
    background: url('../../assets/imgs/slidebar/logo2.png') no-repeat;
    background-size: cover;
    background-position: center;
    transition: width .3s ease-in-out,
      height .3s ease-in-out;
  }
  & > div.slide-bar-logo__close {
    width: 64px;
    height: 64px;
  }
  & .munu-font {
    margin-left: 6px;
  }
}
</style>
